import { getErrorCode, getErrorResponse } from '../../../common/api/errors'

const TEXTS: Record<string, string> = {
  REVISION_NOT_NEEDED: 'Проводить нечего: суммы совпадают с проведённым',
  REVISION_ABOVE_SHORTFALL:
    'Получатель получил больше, чем покрывают исправления, — измените сумму зачисления депозита',
  REVISION_BOUNDS: 'Операция вывела бы сумму за допустимые пределы',
  REVISION_LIMIT_REACHED: 'По этому депозиту больше нельзя проводить изменения',
  PAYOUT_REVISION_LIMIT: 'По выплате уже проведено 5 диспутов с исправлениями',
  REVISION_REMEDY_REQUIRED:
    'Укажите, кто отвечает за недостачу и как получатель получит недостающее',
  LEDGER_REVISION_FAILED: 'Учёт не подтвердил операцию — ничего не изменено, повторите позже',
  LEDGER_POSTING_UNDELIVERED:
    'Проводка депозита ещё не доставлена в учёт — повторите через несколько минут',
  PRICING_UNKNOWN: 'У операции нет сохранённой ставки комиссии — изменение невозможно',
  TICKET_STATE_INVALID: 'Изменить можно только завершённый депозит',
  TICKET_NOT_FOUND: 'Депозит не найден',
  DISPUTE_ALREADY_RESOLVED: 'Диспут уже закрыт',
}

export const settlementErrorText = (code: string | undefined, fallback: string): string =>
  (code && TEXTS[code]) || fallback

export interface SettlementErrorBody {
  errorCode?: string | null
  errors?: Partial<Record<string, string>>
}

// Text by code first; general_error and field errors stay as the fallback for validation.
export const settlementErrorFromBody = (
  data: SettlementErrorBody | undefined,
  fallback: string
): string => {
  const byCode = settlementErrorText(data?.errorCode ?? undefined, '')
  if (byCode) return byCode

  if (data?.errors?.general_error) return data.errors.general_error

  const first = Object.entries(data?.errors ?? {}).find(([, text]) => text)
  return first ? `${first[0]}: ${first[1]}` : fallback
}

// The axios interceptor rejects with error.response itself, so the body is in e.data.
export const settlementErrorFromException = (e: unknown, fallback: string): string =>
  settlementErrorFromBody(
    {
      errorCode: getErrorCode(e),
      errors: getErrorResponse<Record<string, string>>(e) ?? undefined,
    },
    fallback
  )
